/**
 * @param LoginForm Base widget for extending
 * @returns SignInToBuyLoginForm widget
 */
function SignInToBuyLoginFormClassCreator(LoginForm: import('widgets/forms/ajax/LoginForm').TLoginForm) {
    class SignInToBuyLoginForm extends LoginForm {
        /**
         * @description Handles server response
         * @param data - Server JSON response once form submitted
         */
        onSubmitted(data: TServerResponse & { showPasswordResetModalForMigratedCustomer: boolean }) {
            if (data.success) {
                this.emit('signintobuyformsubmit', data);
            }

            super.onSubmitted(data);
        }

        /**
         * @description Handles GTM tracking updates
         */
        handleGTMUpdates(eventName: string, data = {}) {
            this.emit('handlegtmupdates', eventName, data);
        }
    }

    return SignInToBuyLoginForm;
}

export type TSignInToBuyLoginForm = ReturnType<typeof SignInToBuyLoginFormClassCreator>;

export type TSignInToBuyLoginFormInstance = InstanceType<TSignInToBuyLoginForm>;

export default SignInToBuyLoginFormClassCreator;
